<h1>Inaktivitet!</h1>
<mat-dialog-content>
  <br />
  <h3>
    Du har varit inaktiv under för lång tid. Klicka på <b>Anslut</b> nedan.
  </h3>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button type="button" color="primary" mat-dialog-close>Anslut</button>
</mat-dialog-actions>
